<template>
  <span
    :class="[bemBlock, 'price']"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/Offer"
  >
    <meta
      itemprop="priceCurrency"
      :content="price.currency"
    >
    <span
      v-if="title"
      :class="bemElement('title')"
    >
      {{ title }}
    </span>
    <p
      v-if="
        originalPrice
          && originalPrice.text !== null
          && isTotalPrice"
      :class="bemElement('promo-text')"
    >
      {{ $msg('line-item-total-price.promo-text', 'cart') }}
    </p>
    <span
      v-if="originalPrice && originalPrice.text !== null"
      :class="bemElement('original-price')"
    >
      {{ originalPrice.text }}
    </span>
    <span
      :class="bemElement('price')"
      :content="price.value"
      itemprop="price"
    >
      {{ price.text }}
    </span>
    <span
      v-if="hasDiscount()"
      :class="bemElement('discount')"
    >
      {{ formattedDiscountPercent }}
    </span>
  </span>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropPriceMixin from '../mixins/productPropPriceMixin';
import productTagsMixin from '../mixins/productTagsMixin';
import getFrontConfig from '../../common/getFrontConfig';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'BasePrice',

  mixins: [
    bemClassesMixin,
    productPropPriceMixin,
    productTagsMixin,
  ],

  props: {
    context: {
      type: String,
      validator: (prop) => [
        FRONT_CONFIG.vue.BasePrice.context.unitPrice,
        FRONT_CONFIG.vue.BasePrice.context.totalPrice,
      ].includes(prop),
      default: FRONT_CONFIG.vue.BasePrice.context.unitPrice,
    },
    title: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isTotalPrice: this.context === FRONT_CONFIG.vue.BasePrice.context.totalPrice,
    };
  },

  computed: {
    formattedDiscountPercent() {
      return `${this.discountPercent}%`;
    },
  },
};
</script>
